/* @format */
import React from 'react'
import PropTypes from 'prop-types'
import pure from 'recompose/pure'
import compose from 'recompose/compose'
import { connect } from 'react-redux'

import themed from '@/ui/Theme/themed'
import translate from '@/i18n/translate'
import AutoComplete from '@/ui/Input/AutoComplete'

export const AutoCompleteField = ({
  meta: { touched, error } = {},
  input: { value, name, onChange, onBlur, ...inputProps },
  translate,
  filter,
  ...props
}) => {
  const val = typeof value !== undefined && props.source ? props.source[value] : value
  const bb = vv => {
    onBlur(value)
  }
  return (
    <AutoComplete
      {...props}
      value={val}
      multiple={false}
      onBlur={bb}
      error={touched && error}
      className={'form-group'}
      showSelectedWhenNotInSource={true}
      showSuggestionsWhenValueIsSet={true}
      direction={'down'}
      onChange={val => onChange(val | 0 || null)}
    />
  )
}

AutoCompleteField.propTypes = {
  // resource: PropTypes.string,
  // source: PropTypes.string,
  // label: PropTypes.string,
  translate: PropTypes.func.isRequired,
}

const mapStateToProps = connect((state, props) => ({
  source:
    state.rest[props.src] &&
    state.rest[props.src].data &&
    Object.entries(state.rest[props.src].data).reduce((res, key) => {
      // If filter is passed, filter provided data with it (filter items that don't pass the filter)
      if (props.filter && !!props.filter(key[1])) return res
      res[key[0]] = key[1][props.titleProperty]
      return res
    }, {}),
}))

const enhance = compose(pure, themed, translate, mapStateToProps)

export default enhance(AutoCompleteField)



// WEBPACK FOOTER //
// ./ui/Data/AutoCompleteField.js